const config = require("../config")
const url = config.base_dev_url + "z_farm_work_pesticide_fertilizer"

module.exports = {
    // 分页查询药肥数据 v1版本
    fertilizerList: {
        url: url + "/v1/page/{page}/{limit}",
        type: "get",
    },
    // 药肥详情（该方法农资专用）
    fertilizerDetail: {
        url: url + "/v1_store_detail",
        type: "get",
    },
    // 药肥下拉数据
    selectOption: {
        url: url + "/selectOption",
        type: "get",
    },
    // 保存药肥信息V1版本（包含定价、成本、库存信息）
    saveFertilizer: {
        url: url + "/save_v1",
        type: "post",
    },
    // 药费类型列表
    typeList: {
        url: config.base_dev_url + "z_farm_work_pesticide_fertilizer_category/tree",
        type: "get",
    },
    // 层级
    firstLevelOptions: {
        url: url + "_category" + "/firstLevelOptions",
        type: "get",
    },
    // 删除药肥
    deleteFertilizer: {
        url: url + "/delete",
        type: "get",
    },
}